import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReceiptDetailsComponent } from 'src/app/Sets/receipt-details/receipt-details.component';
import { ALERT_TYPE } from 'src/app/constants';
import { Account } from 'src/model/account.model';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';
import { ConstructAPI } from '../../API/constructAPI';
import { RestApiService } from '../../API/restapi';
import { SharedService } from '../../Shared/shared-service.service';

@Component({
    selector: 'app-add-simpan',
    templateUrl: './add-simpan.component.html',
    styleUrls: ['./add-simpan.component.scss'],
    standalone: false
})
export class AddSimpanComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];
  selectedAccountId: number;

  amount: number;
  simpanDate: Date = new Date();
  remark: string;

  @Input() isModal = false;
  @Input() selectedProfileID: number;
  @Input() selectedProfile: Profile;
  @Input() selectedCustomer: Customer;

  @Output() passEntry = new EventEmitter<any>();

  addedSimpanSetId: number;

  disabledSubmit = false;

  ngOnInit(): void {
    const companyId = Number(sessionStorage.getItem("companyId"));
    this.getAllAccountsOfCompany(companyId);
  }

  fieldIsNull() {
    const amountNull = this.amount == undefined || this.amount == 0;
    const remarkNull = this.remark == undefined;
    const accountNull = this.selectedAccountId == undefined;

    return amountNull || remarkNull || accountNull
  }

  submit() {
    if (this.fieldIsNull() == true) {
      this.sharedService.openAlert("Please fill in all fields correctly", ALERT_TYPE.DANGER);
    } else {
      this.addSimpan();
    }
  }

  reset() {
    this.activeModal.close();
  }

  private getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else {
            if (this.sharedService.isStaff()) {
              if (account.Username == loggedInUsername)
                this.cashAccountList.push(account);
            }
            else {
              this.cashAccountList.push(account);
            }
          }
        });
      }
    };
  }

  addSimpan() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.simpanDate))).toISOString();

    const data = {
      "reserve": this.amount,
      "accountId": Number(this.selectedAccountId),
      "dateCreated": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddReserve(this.selectedProfileID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);

          //if this is a shared profile and user logged in is main profile

          if (this.selectedProfile != undefined && this.selectedProfile.SharedProfileId == this.selectedProfile.ID) {
            const addedSimpanTransactionId = Number(json.id);
            this.addSimpanIncomeSet([addedSimpanTransactionId]);
          } else {
            this.continueSimpanAction();
          }
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  continueSimpanAction() {
    this.sharedService.openAlert("Successfully added simpan!", ALERT_TYPE.SUCCESS);

    if (this.addedSimpanSetId != undefined) {
      this.activeModal.close();
      const modalRef = this.sharedService.openModal(ReceiptDetailsComponent, "largeModal");
      modalRef.componentInstance.receiptId = Number(this.addedSimpanSetId);
      modalRef.componentInstance.isModal = true;
      modalRef.componentInstance.passEntry.subscribe((entry) => {
        window.location.reload();
      });
    }
    else {
      if (this.isModal == true) {
        this.passEntry.emit(this.amount);
        this.activeModal.close();
      }
      else
        window.location.reload();
    }
  }

  addSimpanIncomeSet(idsToAdd: number[]) {
    this.disabledSubmit = true;

    const companyId = Number(sessionStorage.getItem("companyId"))
    const data = {
      "transactionIds": idsToAdd,
      "remark": "SIMPAN " + this.selectedCustomer.Name + " (" + this.selectedCustomer.ICNumber + ")",
      "name": "EPF SIMPAN PAYMENT "
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAddNewCompanySet(companyId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          var json = JSON.parse(xhr.responseText);
          this.addedSimpanSetId = Number(json.id);

          this.continueSimpanAction();
        }
        else {
          var json = JSON.parse(xhr.responseText);
          this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER)
        }
      }
    }
  }
}
